import { topicItems } from '@/mocks/homeData';

export default function Topics() {
  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return 'ri-arrow-up-line text-primary-500';
    if (trend === 'down') return 'ri-arrow-down-line text-foreground-400';
    return 'ri-subtract-line text-foreground-400';
  };

  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            全网最热话题实时追踪，点击探索你感兴趣的吃瓜内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2.5 md:gap-3 max-w-[960px] mx-auto">
          {topicItems.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-1.5 px-3.5 py-2 md:px-4 md:py-2.5 bg-background-100 border border-background-200/70 rounded-full hover:border-primary-300 hover:bg-primary-50/40 transition-all duration-200 group cursor-pointer"
            >
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.name}
              </span>
              {item.tag && (
                <span className={`inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-semibold whitespace-nowrap ${
                  item.tag === '爆'
                    ? 'bg-primary-500 text-background-50'
                    : item.tag === '热'
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-secondary-500 text-background-50'
                }`}>
                  {item.tag}
                </span>
              )}
              <span className="text-[11px] text-foreground-500 whitespace-nowrap">{item.heat}</span>
              <i className={`${getTrendIcon(item.trend)} text-xs`}></i>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#index"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium hover:text-primary-600 transition-colors cursor-pointer"
          >
            浏览全部话题 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}